import { useLayoutEffect, useMemo } from 'react';

import { GridValidRowModel } from '@mui/x-data-grid';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import useSortableCollection from '../useSortableCollection';

export default function useSortableCollectionSearchParams<R extends GridValidRowModel = GridValidRowModel>(ns?: string) {
  const { sortModel, onSortModelChange } = useSortableCollection<R>();

  const [{ sortField, sortOrder }, updateSortableQuery] = useQueryParams({
    sortField: { ...StringParam, urlName: ns ? `${ns}SortField` : undefined },
    sortOrder: { ...NumberParam, urlName: ns ? `${ns}SortOrder` : undefined },
  });

  useLayoutEffect(() => {
    const sortField = sortModel?.[0]?.field;
    const sortOrder = sortModel?.[0]?.sort ? (sortModel[0].sort === 'desc' ? -1 : 1) : undefined;
    updateSortableQuery(({ sortField: _sortField, sortOrder: _sortOrder, ...rest }) => ({
      ...rest,
      sortField: sortField,
      sortOrder: sortOrder,
    }));
  }, [sortModel, updateSortableQuery]);

  return useMemo(
    () => ({
      searchParams: (sortField && typeof sortOrder === 'number'
        ? {
            sortField: sortField,
            sortOrder: sortOrder,
          }
        : {}) as { sortField: Exclude<keyof R, symbol>; sortOrder: 1 | -1 },
      sortModel,
      onSortModelChange,
    }),
    [onSortModelChange, sortField, sortOrder, sortModel],
  );
}
